if (!customElements.get("card-product")) {
    const fetchConfig = (type = 'json') => {
        return {
            method: 'POST',
            headers: {
                'Content-Type': `application/${type}`,
                'Accept': `application/${type}`
            }
        };
    };


    class CardProduct extends HTMLElement {
        constructor() {
            super(),
            !this.classList.contains("disabled") && (this.swatches = this.querySelector(".js-swatches"),
                this.btnToggleSizes = this.querySelector(".js-btn-toggle-sizes"),
                this.defaultMedia = this.querySelector(".js-media-default"),
                this.duplicateSizes(),
                this.setAccessibility(),
                this.initialSizeBtns = this.sizesContent.querySelectorAll(".js-btn-size"),
                this.duplicateSizeBtns = this.duplicatedSizesContent.querySelectorAll(".js-btn-size"),
                this.sizeBtns = [...this.initialSizeBtns, ...this.duplicateSizeBtns],
                this.btnToggleSizes.addEventListener("click", e => {
                        if (e.preventDefault(),
                            !this.duplicatedSizesContainer)
                            return;
                        const btnId = this.btnToggleSizes.dataset.id
                            , sizesContent = this.duplicatedSizesContainer.querySelector(`.js-sizes-content[data-id="${btnId}"]`);
                        this.showSizes(sizesContent)
                    }
                ),
                this.duplicatedSizesContent.addEventListener("click", e => {
                        if (!e.target.classList.contains("js-sizes-content"))
                            return;
                        const sizesContent = e.target;
                        this.hideSizes(sizesContent)
                    }
                ),
                this.duplicatedSizesContent.addEventListener("keydown", e => {
                        e.key === "Escape" && this.hideSizes(this.duplicatedSizesContent)
                    }
                ),
                this.duplicatedSizesContent.addEventListener("keydown", e => {
                        if (!(e.key === "Tab"))
                            return;
                        const isFirstElementFocused = document.activeElement === this.firstFocusableElement
                            , isLastElementFocused = document.activeElement === this.lastFocusableElement;
                        e.shiftKey && isFirstElementFocused ? (this.lastFocusableElement.focus(),
                            e.preventDefault()) : !e.shiftKey && isLastElementFocused && (this.firstFocusableElement.focus(),
                            e.preventDefault())
                    }
                ),
                window.addEventListener("resize", () => {
                        const isMobile = window.innerWidth < 992
                            , isSizeContentVisible = this.duplicatedSizesContent.classList.contains("is-visible")
                            , hasHover = matchMedia("(hover: hover)").matches;
                        isMobile || !isSizeContentVisible || !hasHover || this.hideSizes(this.duplicatedSizesContent)
                    }
                ),
                this.sizesContent.addEventListener("click", this.handleBtnSizeClick.bind(this)),
                this.duplicatedSizesContent.addEventListener("click", this.handleBtnSizeClick.bind(this))),
            this.swatches && (this.btnSwatches = this.swatches.querySelectorAll(".js-btn-swatch"),
                this.swatches.addEventListener("change", e => {
                        if (!e.target.classList.contains("js-btn-swatch"))
                            return;
                        const btnSwatch = e.target;
                        if (btnSwatch.classList.contains("is-active"))
                            return;
                        const btnSwatchColor = btnSwatch.dataset.color
                            , btnSwatchColorHyphenated = btnSwatchColor.toLowerCase().replace(" ", "-")
                            , activeBtnSwatch = this.swatches.querySelector(".js-btn-swatch.is-active")
                            , currentVisibleMedia = this.querySelector('[class*="js-media"].is-visible')
                            , newVisibleMedia = this.querySelector(`.js-media-${btnSwatchColorHyphenated}`);
                        if (activeBtnSwatch.classList.remove("is-active"),
                            btnSwatch.classList.add("is-active"),
                            newVisibleMedia ? (currentVisibleMedia.classList.remove("is-visible"),
                                newVisibleMedia.classList.add("is-visible")) : this.defaultMedia && (currentVisibleMedia.classList.remove("is-visible"),
                                this.defaultMedia.classList.add("is-visible")),
                        !this.btnToggleSizes || (this.sizesContent.querySelector(".js-messages.is-visible")?.classList.remove("is-visible"),
                            this.classList.contains("is-requesting")))
                            return;
                        this.toggleBtns(),
                            (async () => {
                                    try {
                                        const matchingColorVariants = (await this.getProduct()).variants.filter(variant => variant.options.includes(btnSwatchColor));
                                        this.sizeBtns.forEach(sizeBtn => {
                                                const size = sizeBtn.dataset.size
                                                    ,
                                                    matchingSizeVariant = matchingColorVariants.find(matchingColorVariant => matchingColorVariant.options.includes(size));
                                                if (matchingSizeVariant && matchingSizeVariant.available) {
                                                    sizeBtn.setAttribute("aria-disabled", !1),
                                                        sizeBtn.classList.remove("is-disabled");
                                                    return
                                                }
                                                sizeBtn.setAttribute("aria-disabled", !0),
                                                    sizeBtn.classList.add("is-disabled")
                                            }
                                        )
                                    } catch (error) {
                                        console.error(error)
                                    } finally {
                                        this.toggleBtns()
                                    }
                                }
                            )()
                    }
                ))
        }

        async getProduct() {
            try {
                return await (await fetch(`${window.Shopify.routes.root}products/${this.dataset.handle}.js`)).json()
            } catch (error) {
                console.error(error)
            }
        }

        duplicateSizes() {
            this.sizesContent = this.querySelector(".js-sizes-content"),
                this.duplicatedSizesContent = this.sizesContent.cloneNode({
                    deep: !0
                }),
                this.duplicatedSizesContainer = document.querySelector(".js-card-sizes-duplicate"),
            this.duplicatedSizesContainer || (this.duplicatedSizesContainer = document.createElement("div"),
                this.duplicatedSizesContainer.classList.add("js-card-sizes-duplicate"),
                document.body.insertAdjacentElement("beforeend", this.duplicatedSizesContainer)),
                this.duplicatedSizesContainer.insertAdjacentElement("beforeend", this.duplicatedSizesContent)
        }

        handleBtnSizeClick(e) {
            if (!e.target.classList.contains("js-btn-size"))
                return;
            const btnSize = e.target
                , isDisabled = btnSize.classList.contains("is-disabled");
            if (this.classList.contains("is-requesting") || isDisabled)
                return;
            const btnSwatchActive = this.querySelector(".js-btn-swatch.is-active")
                , selectedSize = btnSize.dataset.size
                , selectedColor = btnSwatchActive?.dataset.color
                , targetSizesContent = btnSize.closest(".js-sizes-content")
                , sizeMessagesContainer = targetSizesContent.querySelector(".js-messages")
                , sizeMessageSuccess = targetSizesContent.querySelector(".js-success-message")
                , sizeMessageError = targetSizesContent.querySelector(".js-error-message");
            this.toggleBtns(),
                (async () => {
                        try {
                            const matchingVariant = (await this.getProduct()).variants.find(variant => {
                                    const matchesSize = variant.options.includes(selectedSize)
                                        , matchesColor = btnSwatchActive ? variant.options.includes(selectedColor) : !0;
                                    return matchesSize && matchesColor
                                }
                            );
                            if (!matchingVariant || !matchingVariant.available)
                                return;
                            const formData = new FormData;
                            if (formData.append("id", matchingVariant.id),
                                formData.append("quantity", 1),
                            window.location.pathname === "/cart") {
                                const cartDrawerForm = document.getElementById("CartDrawer-FormSummary");
                                cartDrawerForm && cartDrawerForm.submit()
                            }
                            formData.append("sections_url", window.location.pathname);
                            const config = fetchConfig("javascript");
                            config.headers["X-Requested-With"] = "XMLHttpRequest",
                                delete config.headers["Content-Type"],
                                config.body = formData;
                            const addToCartResponse = await fetch(`/cart/add`, config)
                                , addToCartData = await addToCartResponse.json();
                            if (!addToCartResponse.ok)
                                throw new Error(addToCartData.description);
                            sizeMessageSuccess.classList.remove("hidden"),
                                sizeMessageError.classList.add("hidden");
                        } catch (error) {
                            const errorTextEl = sizeMessageError.querySelector("[data-text]");
                            sizeMessageSuccess.classList.add("hidden"),
                                sizeMessageError.classList.remove("hidden"),
                                errorTextEl.textContent = error.message
                        } finally {
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                bubbles: true
                            }));
                            this.toggleBtns(),
                                sizeMessagesContainer.classList.add("is-visible"),
                                setTimeout(() => {
                                        sizeMessagesContainer.classList.remove("is-visible")
                                    }
                                    , 4e3)
                        }
                    }
                )()
        }

        setAccessibility() {
            const duplicatedSizesContentId = `SizesPopup-${this.sizesContent.dataset.id}`;
            this.duplicatedSizesContent.id = duplicatedSizesContentId,
                this.btnToggleSizes.setAttribute("aria-expanded", !1),
                this.btnToggleSizes.setAttribute("aria-controls", duplicatedSizesContentId)
        }

        toggleBtns() {
            this.classList.toggle("is-requesting"),
                this.btnSwatches?.forEach(btnSwatch => btnSwatch.toggleAttribute("disabled")),
            this.btnToggleSizes && (this.sizesContent.classList.toggle("overlay-visible"),
                this.duplicatedSizesContent.classList.toggle("overlay-visible"))
        }

        showSizes(container) {
            this.btnToggleSizes.setAttribute("aria-expanded", !0),
                container.classList.add("is-visible"),
                document.body.style.overflow = "hidden";
        }

        hideSizes(container) {
            this.btnToggleSizes.setAttribute("aria-expanded", !1),
                container.classList.remove("is-visible"),
                document.body.style.overflow = "",
                this.btnToggleSizes.focus()
        }
    }

    customElements.define("card-product", CardProduct)
}